import React, { useRef, useEffect, useState } from 'react';

interface ScrollableDescriptionProps {
    children: React.ReactNode;
    className?: string;
    maxHeight?: string;
}

const ScrollableDescription: React.FC<ScrollableDescriptionProps> = ({
    children, 
    className = '', 
    maxHeight = 'max-h-48' 
}) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const checkScrollable = () => {
            if (contentRef.current) {
                const { scrollHeight, clientHeight } = contentRef.current;
                setIsScrollable(scrollHeight > clientHeight);
            }
        };

        checkScrollable();
        // Re-check on window resize
        window.addEventListener('resize', checkScrollable);
        return () => window.removeEventListener('resize', checkScrollable);
    }, [children]);

    return (
        <div className={`${isScrollable ? 'border border-gray-200 rounded-md p-3' : ''} ${className}`}>
            <div 
                ref={contentRef}
                className={`whitespace-pre-line break-words ${maxHeight} overflow-y-auto`}
            >
                {children}
            </div>
        </div>
    );
};

export default ScrollableDescription; 